import { Default } from '@core/util';
import { Exclude, Expose, Type } from 'class-transformer';
import { BeneficialOwnerModel } from './beneficial-owner.model';
import { ApplicationForCorporateAccount } from './application.model';

@Exclude()
export class BusinessAccountModel extends ApplicationForCorporateAccount {
  @Expose({ toClassOnly: true })
  applicationForCorporateAccount!: boolean;

  @Expose({ toClassOnly: true })
  @Type(() => BeneficialOwnerModel)
  @Default([])
  beneficialOwners!: BeneficialOwnerModel[];
}
